import React, { useState } from "react";
import {
  Radio,
  Plus,
  Settings
} from "lucide-react";
import { AddMikrotikRouterModal } from "../components/common/AddMikrotikRouterModal";
import { RealRoutersList } from "../components/common/RealRoutersList";
import { RemoteModemConfigModal } from "../components/common/RemoteModemConfigModal";
import { useAuth } from "../context/AuthContext";

export const JaringanMikrotikPage = () => {
  const { user } = useAuth();
  const canManageRouter = user?.role === "admin" || user?.role === "finance";
  const [showAddModal, setShowAddModal] = useState(false);
  const [showRemoteModal, setShowRemoteModal] = useState(false);
  const [realRefreshKey, setRealRefreshKey] = useState(0);

  return (
    <div className="space-y-6" data-testid="mikrotik-page">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl">
        <div>
          <div className="flex items-center gap-2">
            <span className="px-2 py-0.5 rounded bg-blue-500/20 text-blue-400 text-[10px] font-bold uppercase tracking-wider">
              RouterOS API Management
            </span>
            <span className="text-xs text-slate-400">Port 8728 / SSL</span>
          </div>
          <h1 className="text-xl sm:text-2xl font-black text-white mt-1">
            Dashboard Mikrotik & Monitoring RouterOS
          </h1>
          <p className="text-xs text-slate-400 mt-0.5">
            Monitoring interface ether, CPU/RAM, sesi PPPoE, dan isolir otomatis pelanggan.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {canManageRouter && (
          <button
            onClick={() => setShowRemoteModal(true)}
            data-testid="remote-modem-btn"
            className="px-4 py-2 bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:from-violet-500 hover:to-fuchsia-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-violet-600/30 flex items-center gap-2 transition-all"
          >
            <Settings className="w-4 h-4" />
            <span>Remote Modem</span>
          </button>
          )}
          {canManageRouter && (
          <button
            onClick={() => setShowAddModal(true)}
            data-testid="add-router-btn"
            className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-emerald-600/30 flex items-center gap-2 transition-all"
          >
            <Plus className="w-4 h-4" />
            <span>Tambah Router</span>
          </button>
          )}
        </div>
      </div>

      {/* Real Routers Section - Live RouterOS API */}
      <div className="space-y-3" data-testid="real-routers-section">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-1 h-4 bg-gradient-to-b from-emerald-400 to-teal-500 rounded-full" />
            <h2 className="text-sm font-bold text-white flex items-center gap-2">
              <Radio className="w-4 h-4 text-emerald-400" />
              Router Real (Live RouterOS API)
            </h2>
            <span className="px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-300 border border-emerald-500/30 text-[10px] font-bold uppercase">
              Live
            </span>
          </div>
          <span className="text-[11px] text-slate-500">v6.43+ & v7 • IP Publik / VPN</span>
        </div>
        <RealRoutersList refreshKey={realRefreshKey} onDeleted={() => setRealRefreshKey((k) => k + 1)} />
      </div>

      {/* Add Router Modal */}
      {showAddModal && (
        <AddMikrotikRouterModal
          onClose={() => setShowAddModal(false)}
          onSuccess={() => setRealRefreshKey((k) => k + 1)}
        />
      )}

      {/* Remote Modem Config Modal */}
      {showRemoteModal && (
        <RemoteModemConfigModal
          onClose={() => setShowRemoteModal(false)}
          onSuccess={() => setRealRefreshKey((k) => k + 1)}
        />
      )}
    </div>
  );
};
